import * as Sentry from '@sentry/browser';

const HtmlBoxRegWall = (boxes: NodeListOf<HTMLDivElement>) => {
  boxes.forEach((box, boxIndex) => {
    // NALOGOVANÝ UŽIVATEL | Pokud url obsahuje potřebnou kotvu
    const anchorElement: HTMLTemplateElement | null = box.querySelector(
      '[data-html-box-reg-wall-anchor]'
    );
    if (anchorElement) {
      const { htmlBoxRegWallAnchor } = anchorElement.dataset;

      if (htmlBoxRegWallAnchor && window.location.search.includes(`${htmlBoxRegWallAnchor}`)) {
        // Počkat na načtení stránky
        window.addEventListener('load', () => {
          const embedBlock: HTMLElement | null = document.getElementById(htmlBoxRegWallAnchor);

          // Pokud je blok nalezen, posunout se k němu
          if (embedBlock)
            window.scrollTo({
              top: embedBlock.getBoundingClientRect().top - 70 + window.scrollY,
              behavior: 'smooth',
            });
          else Sentry.captureException('HtmlBoxRegWall: Element odkazovaný v kotvě nenalezen.');
        });
      }
    }

    // NELOGOVANÝ UŽIVATEL | Po kliknutí na tlačítko zaznamenat Meiro událost
    const button: HTMLElement | null = box.querySelector('[data-html-box-reg-wall-button]');
    if (button) {
      button.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        const MeiroEvents = window.MeiroEvents;

        // Pokud je na stránce MeiroEvents a kliknutý element obsahuje data-id a data-title
        if (target && typeof MeiroEvents === 'object') {
          const infoGrafWrapper: HTMLElement | null = target.parentElement
            ?.parentElement as HTMLElement;
          if (infoGrafWrapper) {
            const infoGraf: HTMLElement | null =
              infoGrafWrapper.querySelector('[data-id][data-title]');

            if (infoGraf) {
              const { id, title: name } = infoGraf.dataset;

              if (id && name) {
                // Zaznamenat Meiro událost
                MeiroEvents.track('customEvent', {
                  action: 'locked_content_clicked',
                  name,
                  id,
                });
              }
            } else {
              // Zaznamenat Meiro událost bez podrobných parametrů
              MeiroEvents.track('customEvent', {
                action: 'locked_content_clicked',
                name: `html-box-${boxIndex}`,
              });
            }
          }
        }
      });
    }
  });
};

export default HtmlBoxRegWall;
